













































import {
  apiCollectionCommodityCancel,
  apiCollectionCommodityList,
} from '@/api'
import { defineClassComponent } from '@/hooks'
import { defineTvListeners } from '../utils'
import { makeUniGoods, submit, Track, UniGoods } from '@/utils'
import { navigateTo } from '@/router'
import { onMounted, ref } from '@vue/composition-api'
import { useWaterfall, XWaterfallLoad } from '@/components'

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          // 埋点页面名称
          page: 'TV-我的收藏',
        }))

        onMounted(() => {
          this.loading.value = false
        })
      }

      // 加载状态
      loading = ref(true)

      // 操作索引
      actionIndex = ref(0)

      waterfall = useWaterfall('waterfall')

      // 加载列表数据
      loadData: XWaterfallLoad = ({ pageNumber }) => {
        return apiCollectionCommodityList({
          pageIndex: pageNumber,
          pageSize: 10,
        }).then(res => {
          if (pageNumber === 1 && res.list!.length) {
            setTimeout(() => this.goToList(0), 60)
          }
          return makeUniGoods(res.list!)
        })
      }

      // 跳到搜索
      goToSearch = () => {
        ctx.$tv.goTo(ctx.$refs.search as any)
      }

      // 跳到列表
      goToList = (index: number) => {
        ctx.$tv.goTo((ctx.$refs.list as any).$el, index)
      }

      // 搜索监听器
      searchListeners = defineTvListeners(({ type }) => {
        switch (type) {
          case 'up':
          case 'left':
            this.goToSearch()
            break
          case 'down':
          case 'right':
            this.goToList(0)
            break
          case 'click':
            navigateTo('TvSearchIndex')
            break
          default:
            break
        }
      })

      // 列表监听器
      listListeners = defineTvListeners<UniGoods>(
        ({ type, index, isFirst, isLast, item }) => {
          switch (type) {
            case 'focus':
              this.actionIndex.value = 1
              break
            case 'up':
              if (this.actionIndex.value > 0) {
                this.actionIndex.value -= 1
                this.goToList(index)
              } else if (index < 5) {
                this.goToSearch()
              }
              break
            case 'down':
              if (this.actionIndex.value < 1) {
                this.actionIndex.value += 1
                this.goToList(index)
              }
              break
            case 'left':
              if (isFirst) {
                this.goToSearch()
              } else {
                this.goToList(index - 1)
              }
              break
            case 'right':
              if (!isLast) {
                this.goToList(index + 1)
              } else {
                this.goToList(-1)
              }
              break
            case 'click':
              if (this.actionIndex.value === 0) {
                submit(async $ => {
                  $.start()
                  await apiCollectionCommodityCancel({
                    skuIdList: [item.raw.skuId],
                  })
                  this.waterfall.reload()
                  await $.success('移除收藏成功')
                })
              } else if (this.actionIndex.value === 1) {
                navigateTo('TvGoodsIndex', {
                  id: item.id,
                })
              }
              break
            default:
              break
          }
        },
      )
    },
)
